import { create } from "zustand";
import { PREMIUM_JOB, zustandFetchStates } from "../services/constants";
import CreditService from "../services/CreditService";

interface WithJobId {
  jobId: number;
  categoryId?: never;
  cityId?: never;
}

interface WithCategoryAndCity {
  jobId?: never;
  categoryId: number;
  cityId: string;
}

type FetchDataParams = WithJobId | WithCategoryAndCity;

const useSingleJobSkus = create((set, get: any) => ({
  fetchState: zustandFetchStates.IDLE,
  data: [],
  paramsHash: "",
  premiumSku: {},
  basicSku: {},
  boostPlanInfo: {},
  fetchData: async (params: FetchDataParams): Promise<any> => {
    const { jobId, categoryId, cityId } = params;
    const paramsHash = Object.values(params).join("_");
    if (
      paramsHash === get().paramsHash &&
      (get().fetchState === zustandFetchStates.LOADING ||
        get().fetchState === zustandFetchStates.SUCCESS)
    ) {
      if (get().fetchState === zustandFetchStates.SUCCESS) {
        return { premiumSku: get().premiumSku, basicSku: get().basicSku };
      }
      return {};
    }
    try {
      set({
        fetchState: zustandFetchStates.LOADING,
        paramsHash
      });
      const query = {
        ...(jobId ? { jobId } : {}),
        ...(categoryId ? { categoryId } : {}),
        ...(cityId ? { cityId } : {})
      };
      const data = await CreditService.skusForSingleJob(query);
      const premiumSku =
        data.find((sku: any) => sku.productType === "PREMIUM_JOB") ?? {};
      const basicSku =
        data.find((sku: any) => sku.productType === "BASIC_JOB") ?? {};
      const boostPlanInfo =
        data.find((sku: any) => sku.productType === "JOB_MINI_PLAN") ?? {};
      const downloadSku =
        data.find((sku: any) => sku.productType === "CANDIDATE_DOWNLOAD") ?? {};
      set({
        fetchState: zustandFetchStates.SUCCESS,
        data,
        premiumSku,
        basicSku,
        boostPlanInfo,
        downloadSku
      });
      return {
        data,
        premiumSku,
        basicSku,
        boostPlanInfo,
        downloadSku
      };
    } catch (error) {
      set({
        fetchState: zustandFetchStates.ERROR,
        data: [],
        premiumSku: {},
        basicSku: {},
        boostPlanInfo: {},
        downloadSku: {}
      });
      return {
        data: [],
        premiumSku: {},
        basicSku: {},
        boostPlanInfo: {},
        downloadSku: {}
      };
    }
  }
}));
export default useSingleJobSkus;
